module.exports = __webpack_public_path__ + "static/media/Combined Shape Copy 2@1.5x.37d0fb88.svg";